import { render, staticRenderFns } from "./FnFormatFileSize.vue?vue&type=template&id=1386b197&"
import script from "./FnFormatFileSize.vue?vue&type=script&lang=js&"
export * from "./FnFormatFileSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1386b197')) {
      api.createRecord('1386b197', component.options)
    } else {
      api.reload('1386b197', component.options)
    }
    module.hot.accept("./FnFormatFileSize.vue?vue&type=template&id=1386b197&", function () {
      api.rerender('1386b197', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-format/components/FnFormatFileSize.vue"
export default component.exports